import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { CartProvider, useCart } from "../context/CartContext";
import { PRODUCTS } from "../mock";
import { ShoppingBag, Filter } from "lucide-react";

const FILTERS = ["All", "Raw", "Roasted", "Best seller", "Premium", "Organic"];

const ShopInner = () => {
  const [filter, setFilter] = useState("All");
  const [sort, setSort] = useState("featured");
  const navigate = useNavigate();
  const { addItem } = useCart();

  let list = [...PRODUCTS];
  if (filter !== "All") list = list.filter((p) => p.badges?.includes(filter));
  if (sort === "price-asc") list.sort((a, b) => a.price - b.price);
  if (sort === "price-desc") list.sort((a, b) => b.price - a.price);
  if (sort === "name") list.sort((a, b) => a.name.localeCompare(b.name));

  return (
    <>
      <Header />
      <section className="bg-stone-50/60 border-b border-stone-200">
        <div className="max-w-[1300px] mx-auto px-6 lg:px-10 py-14">
          <div className="text-xs tracking-[0.3em] uppercase text-stone-500">Shop</div>
          <h1 className="font-display text-4xl md:text-5xl text-[#c8232c] mt-2">All our nuts</h1>
          <p className="mt-3 text-stone-600 max-w-xl">
            Browse the full collection — from everyday classics to limited harvest specialties.
          </p>
        </div>
      </section>
      <section className="py-10">
        <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
          <div className="flex items-center justify-between mb-8 flex-wrap gap-4">
            <div className="flex items-center gap-2 flex-wrap">
              <Filter size={16} className="text-stone-500" />
              {FILTERS.map((f) => (
                <button
                  key={f}
                  onClick={() => setFilter(f)}
                  className={`text-xs tracking-widest uppercase px-3 py-1.5 border ${
                    filter === f ? "bg-[#c8232c] text-white border-[#c8232c]" : "bg-white text-stone-700 border-stone-300 hover:border-stone-500"
                  }`}
                >
                  {f}
                </button>
              ))}
            </div>
            <select
              value={sort}
              onChange={(e) => setSort(e.target.value)}
              className="text-sm border border-stone-300 px-3 py-2 bg-white"
            >
              <option value="featured">Featured</option>
              <option value="price-asc">Price: low to high</option>
              <option value="price-desc">Price: high to low</option>
              <option value="name">Name A‑Z</option>
            </select>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            {list.map((p) => (
              <div key={p.id} className="product-card group bg-white">
                <button onClick={() => navigate(`/product/${p.slug}`)} className="block w-full text-left">
                  <div className="img-wrap relative overflow-hidden bg-stone-50 aspect-square">
                    <img src={p.image} alt={p.name} className="absolute inset-0 w-full h-full object-cover" loading="lazy"/>
                    <div className="absolute top-3 left-3 flex gap-2">
                      {p.badges?.map((b) => (
                        <span key={b} className="text-[10px] tracking-widest uppercase bg-white/95 text-stone-800 px-2 py-1 border border-stone-200">{b}</span>
                      ))}
                    </div>
                  </div>
                </button>
                <div className="text-center pt-5 pb-3">
                  <div className="text-[11px] tracking-[0.3em] uppercase text-stone-500">{p.short}</div>
                  <h3 className="font-display text-2xl text-[#c8232c] mt-1">{p.name}</h3>
                  <div className="mt-3 flex items-center justify-center gap-4">
                    <span className="text-stone-900 font-semibold">€{p.price.toFixed(2)}</span>
                    <span className="text-xs text-stone-500">{p.weight}</span>
                  </div>
                  <button onClick={() => addItem(p, 1)} className="mt-4 btn-ghost text-xs tracking-[0.18em] uppercase inline-flex items-center gap-2">
                    <ShoppingBag size={14} /> Add to cart
                  </button>
                </div>
              </div>
            ))}
          </div>
          {list.length === 0 && (
            <div className="text-center text-stone-500 py-16">No nuts match this filter.</div>
          )}
        </div>
      </section>
      <Footer />
    </>
  );
};

const Shop = () => (
  <CartProvider>
    <ShopInner />
  </CartProvider>
);

export default Shop;
